import React, { createContext, useContext, useState } from 'react';

const GOLD = '#C9A84C';

const DARK = {
  id: 'dark',
  gold: GOLD,
  bg: '#0e0e0e',
  surface: 'rgba(255,255,255,0.03)',
  surfaceHover: 'rgba(201,168,76,0.04)',
  border: 'rgba(255,255,255,0.08)',
  borderHover: 'rgba(201,168,76,0.3)',
  text: 'rgba(255,255,255,0.88)',
  textSub: 'rgba(255,255,255,0.5)',
  textMuted: 'rgba(255,255,255,0.32)',
  inputBg: 'rgba(255,255,255,0.04)',
  inputBorder: 'rgba(255,255,255,0.1)',
  inputColor: 'rgba(255,255,255,0.85)',
  label: 'rgba(255,255,255,0.4)',
  dockBg: 'rgba(14,14,16,0.88)',
  dockBorder: '1px solid rgba(255,255,255,0.1)',
  dockBrandText: GOLD,
  iconBg: 'linear-gradient(145deg, #1a1a1a, #0a0a0a)',
  iconColor: '#949188',
  tabActive: GOLD,
  tabInactive: 'rgba(255,255,255,0.45)',
  badgeGold: { bg: GOLD, color: '#0e0e0e' },
  errorBg: 'rgba(127,29,29,0.3)',
  errorBorder: 'rgba(220,38,38,0.35)',
  errorText: '#fca5a5',
};

const LIGHT = {
  id: 'light',
  gold: GOLD,
  bg: '#f1f3f6',
  surface: 'rgba(255,255,255,0.9)',
  surfaceHover: 'rgba(201,168,76,0.06)',
  border: 'rgba(100,116,139,0.2)',
  borderHover: 'rgba(201,168,76,0.4)',
  text: 'rgba(15,23,42,0.9)',
  textSub: 'rgba(15,23,42,0.6)',
  textMuted: 'rgba(15,23,42,0.4)',
  inputBg: 'rgba(255,255,255,0.95)',
  inputBorder: 'rgba(100,116,139,0.3)',
  inputColor: '#0f172a',
  label: 'rgba(15,23,42,0.5)',
  dockBg: 'rgba(230,232,238,0.88)',
  dockBorder: '1px solid rgba(100,116,139,0.2)',
  dockBrandText: GOLD,
  iconBg: 'linear-gradient(145deg, #f6f8fb, #dbe2ec)',
  iconColor: '#334155',
  tabActive: GOLD,
  tabInactive: 'rgba(15,23,42,0.45)',
  badgeGold: { bg: GOLD, color: '#0e0e0e' },
  errorBg: 'rgba(254,242,242,0.96)',
  errorBorder: 'rgba(220,38,38,0.3)',
  errorText: '#b91c1c',
};

export const THEMES = { dark: DARK, light: LIGHT };

const ClientThemeContext = createContext({ theme: DARK, themeId: 'dark', setThemeId: () => {} });

export function ClientThemeProvider({ children }) {
  const [themeId, setThemeIdState] = useState(() => localStorage.getItem('cpTheme') || 'dark');

  const setThemeId = (id) => {
    localStorage.setItem('cpTheme', id);
    setThemeIdState(id);
  };

  const theme = THEMES[themeId] || DARK;

  return (
    <ClientThemeContext.Provider value={{ theme, themeId, setThemeId }}>
      {children}
    </ClientThemeContext.Provider>
  );
}

export const useClientTheme = () => useContext(ClientThemeContext);
